import { gql } from '@apollo/client'
import axios from 'axios'
import keycloak from 'src/utils/commonMethods/keycloak'

export function ASSIGN_CEO() {
  return gql`
    mutation ($memberId: String!, $deleteRole: Boolean) {
      assignCorporateCEO(memberId: $memberId, deleteRole: $deleteRole) {
        success
        message
        memberId
        clientId
      }
    }
  `
}

export function ASSIGN_CORPORATE_ADMIN() {
  return gql`
    mutation ($memberId: String!, $deleteRole: Boolean) {
      assignAdminRoleToMember(memberId: $memberId, deleteRole: $deleteRole) {
        success
        message
        memberId
        clientId
        deleteRole
      }
    }
  `
}

// Downloads Annexure in Employee Management
export const getAnnexure = async (clientId) => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/download/annexure/${clientId}`,
    responseType: 'blob',
    headers: { Authorization: `Bearer ${keycloak.token}` },
  }
  return await axios(config).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `Annexure-${clientId}.xlsx`)
    document.body.appendChild(link)
    link.click()
  })
}

export const getClientDetails = async (clientId) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/getClientDetails/${clientId}`,
    headers: {
      Authorization: `Bearer ${keycloak.token}`,
    },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const initialiseSxpChat = async (body) => {
  const url = `${process.env.REACT_APP_SOCKET_URL}state/projectId/${process.env.REACT_APP_GET_SXP_PROJECT_ID}`
  try {
    await axios
      .put(url, body, {
        headers: { Authorization: `Bearer ${keycloak.token}` },
      })
      .then(() => {
        return
      })
  } catch (err) {
    return err
  }
}

export function LINK_ANNEXURE(client, filterType, location, branch) {
  return gql`
    query GET_ANNEXURE_POLICY_DATA {
      getAnnexurePolicyDetails(
        clientId: "${client}"
        filterType: ${filterType}
        location: "${location}"
        branch: "${branch}"
      ) {
        clientId
        branchData {
          branchName
          policyData {
            gmcPolicies {
              id
              productSubType
              status
              provider {
                name
                image
              }
              policyDocumentURL
              policyNumber
              policyDocument {
                name
                originalName
                size
                storage
                type
                url
                data {
                  id
                  baseUrl
                  form
                  project
                  version
                }
              }
            }
            gpaPolicies {
              id
              productSubType
              status
              provider {
                name
                image
              }
              policyDocumentURL
              policyNumber
              policyDocument {
                name
                originalName
                size
                storage
                type
                url
                data {
                  id
                  baseUrl
                  form
                  project
                  version
                }
              }
            }
            gtlPolicies {
              id
              productSubType
              status
              provider {
                name
                image
              }
              policyDocumentURL
              policyNumber
              policyDocument {
                name
                originalName
                size
                storage
                type
                url
                data {
                  id
                  baseUrl
                  form
                  project
                  version
                }
              }
            }
          }
        }
        locationData {
          locationName
          branchNames
          policyData {
            gmcPolicies {
              id
              productSubType
              status
              provider {
                name
                image
              }
              policyDocumentURL
              policyNumber
              policyDocument {
                name
                originalName
                size
                storage
                type
                url
                data {
                  id
                  baseUrl
                  form
                  project
                  version
                }
              }
            }
            gpaPolicies {
              id
              productSubType
              status
              provider {
                name
                image
              }
              policyDocumentURL
              policyNumber
              policyDocument {
                name
                originalName
                size
                storage
                type
                url
                data {
                  id
                  baseUrl
                  form
                  project
                  version
                }
              }
            }
            gtlPolicies {
              id
              productSubType
              status
              provider {
                name
                image
              }
              policyDocumentURL
              policyNumber
              policyDocument {
                name
                originalName
                size
                storage
                type
                url
                data {
                  id
                  baseUrl
                  form
                  project
                  version
                }
              }
            }
          }
        }
      }
    }
  `
}

export function PORTFOLIO_List_NEW(client, policyHolderType) {
  return gql`
    query {
      getPortfolioV2(clientId: "${client}", clientType: ${policyHolderType}) {
        ctc
        riskScore {
          healthInsurance {
            score
            recommendedValue {
              values
              type
            }
          }
          accidentalInsurance {
            score
            recommendedValue {
              values
              type
            }
          }
          lifeInsurance {
            score
            recommendedValue {
              values
              type
            }
          }
        }
        overallSuggestions{
          priority
          insuranceName
          subTypeName
          riskPercent
          riskLevel
          personalPolicies{
              id
              insuranceType
              subType
              priority
              coverageTypes
              comment
              action
              insuranceTypeImage
          }
          missingPolicies{
              insuranceType
              subType
              priority
              comment
              action
              insuranceTypeImage
              premiumPaid
              sumAssured
          }
      }
        data {
          logo
          aggregated
          insuranceMainName
          insuranceSubTypeName
          recommended {
            values
            type
          }
          company {
            sumAssured
            premium
            claims
          }
          personal {
            sumAssured
            premium
            claims
          }
          coverages {
            coverageName
            coverageDescription
            available
          }
          companyPolicies {
            agentComments
            sysAnnexureDocumentURL
            sysAnnexureDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            coverageDocumentURL
            coverageDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            coverageTypes
            fileName
            policyDocumentURL
            policyNumber
            policyDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            annexureDocumentURL
            annexureDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            id
            status
            clientId
            otherInformation {
              insuredName
              vehicleNumber
              vehicleMakeModel
              tpa
              location
              branch
            }
            policyHolder {
              type
              policyMembers{
                firstName
                lastName
                dateOfBirth
                relation
              }
            }
            issuedOn
            expiresOn
            premiumAmount {
              text
            }
            claimAmount {
              text
            }
            productImage
            sumAssured {
              text
            }
            coverageUpto {
              text
            }
            provider {
              id
              name
              image
            }
            otherInformation {
              insuredName
              vehicleNumber
              vehicleMakeModel
              tpa
              location
              branch
            }
            type
            insuranceType
            productSubType
            policyType
            typeOfPolicy 
            intermediary
          }
          personalPolicies {
            agentComments
            sysAnnexureDocumentURL
            sysAnnexureDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            coverageDocumentURL
            coverageDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            coverageTypes
            fileName
            policyDocumentURL
            policyNumber
            policyDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            annexureDocumentURL
            annexureDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            id
            status
            clientId
            policyHolder {
              type
              policyMembers{
                firstName
                lastName
                dateOfBirth
                relation
              }
            }
            issuedOn
            expiresOn
            premiumAmount {
              text
            }
            claimAmount {
              text
            }
            productImage
            sumAssured {
              text
            }
            coverageUpto {
              text
            }
            provider {
              id
              name
              image
            }
            otherInformation {
              insuredName
              vehicleNumber
              vehicleMakeModel
              tpa
              location
              branch
            }
            type
            insuranceType
            productSubType
            policyType
            typeOfPolicy 
            intermediary
          }
        }
      }
    }
  `
}

export function SINGLE_ANNEXURE_DATA(
  client,
  searched,
  sortField,
  page,
  order,
  rowsPerPage
) {
  return gql`
  query {
    getSingleAnnexureData(page: ${page}, size: ${rowsPerPage}, clientId: "${client}", search: "${searched}",sortField:"${sortField}", sortOrder:${order}) {
        content{
            id
            empId
            employerId
            firstName
            middleName
            lastName
            coverStartDate
            coverEndDate
            numberOfMember
            isCEO
            isCorporatePoc
            isCovered
            primaryPolicyMemberId
            relation
            healthCardURL
            healthCards {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            ctc
            mobileNumber
            email
            dateOfBirth
            dateOfJoining
            dateOfLeaving
            location
            sumAssured {
                text
            }
            dependents {
                id
                firstName
                middleName
                lastName
                gender
                relation
                mobileNumber
                dateOfBirth
                isCEO
                isCorporatePoc
                endorsements{id
                  policyId
                  policyName
                  email
                  clientId
                  createdOn
                  endorsementStatus
                  endorsementType
                  agentEndorsementCopy
                  agentEndorsement {
                    name
                    data {
                      id
                    }
                  }
                  clientEndorsementDoc
                  clientEndorsement {
                    name
                    data {
                      id
                    }
                  }
                  metadata
                  typeImage
                  updatedOn}
                  policies {
                    id
                    clientId
                    status
                    productImage
                    sumAssured {
                        text
                    }
                    coverageUpto {
                        text
                    }
                    provider {
                        id
                        name
                        image
                    }
                    type
                    insuranceType
                    coverageTypes
                    productSubType
                }
            }
            gender
            grade
            policies {
                id
                clientId
                status
                productImage
                sumAssured {
                    text
                }
                coverageUpto {
                    text
                }
                provider {
                    id
                    name
                    image
                }
                type
                insuranceType
                coverageTypes
                productSubType
            }
            endorsements {
              id
              policyId
              policyName
              email
              clientId
              createdOn
              endorsementStatus
              endorsementType
              agentEndorsementCopy
              agentEndorsement {
                name
                data {
                  id
                }
              }
              clientEndorsementDoc
              clientEndorsement {
                name
                data {
                  id
                }
              }
              metadata
              typeImage
              updatedOn
          }
        }
        pageInfo{
            currentPage
            totalPages
            totalCount
        }
    }
  }
  `
}

export function Employee_Search(clientId, id) {
  return gql`
  query {
    employeeSearch(clientId: "${clientId}", memberId: "${id}") {
            id
            empId
            employerId
            firstName
            middleName
            lastName
            ctc
            coverStartDate
            coverEndDate
            numberOfMember
            isCovered
            primaryPolicyMemberId
            relation
            healthCardURL
            healthCards {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            dateOfBirth
            dateOfJoining
            location
            sumAssured {
                text
            }
            dependents {
                id
                firstName
                middleName
                lastName
                relation
            }
            gender
            grade
            policies {
                              agentComments
             sysAnnexureDocumentURL
              sysAnnexureDocument {
                name
                originalName
                size
                storage
                type
                url
                data {
                  id
                  baseUrl
                  form
                  project
                  version
                }
              }
              coverageDocumentURL
              policyUploadedMethod
              coverageDocument {
                name
                originalName
                size
                storage
                type
                url
                data {
                  id
                  baseUrl
                  form
                  project
                  version
                }
              }
              coverageTypes
              individualCoverageTypes
              fileName
              policyDocumentURL
              policyNumber
              coverRange
              policyDocument {
                name
                originalName
                size
                storage
                type
                url
                data {
                  id
                  baseUrl
                  form
                  project
                  version
                }
              }
              annexureDocumentURL
              annexureDocument {
                name
                originalName
                size
                storage
                type
                url
                data {
                  id
                  baseUrl
                  form
                  project
                  version
                }
              }
              id
              status
              clientId
              companyName
              otherInformation {
                insuredName
                vehicleNumber
                vehicleMakeModel
                tpa
                location
                branch
              }
              familyDefinition
              policyHolder {
                id
                type
                firstName
                lastName
                policyMembers {
                  firstName
                  lastName
                  dateOfBirth
                  relation
                  healthCardURL
                  healthCards {
                    name
                    data {
                      id
                    }
                  }
                }
                policyId
              }
              issuedOn
              expiresOn
              premiumAmount {
                text
              }
              claimAmount {
                text
              }
              productImage
              sumAssured {
                text
              }
              coverageUpto {
                text
              }
              provider {
                id
                name
                image
              }
              type
              insuranceType
              productSubType
              policyType
              typeOfPolicy 
              intermediary
              totalNoOfEmployees
              isCompanyPolicy
              isCovid19Covered
            }
            policyCount
            email
            mobileNumber
            endorsements{
                agentEndorsementCopy
                agentEndorsement {
                  name
                  data {
                    id
                  }
                }
                clientEndorsementDoc
                clientEndorsement {
                  name
                  data {
                    id
                  }
                }
                clientId
                createdOn
                email
                endorsementStatus
                endorsementType
                id
                metadata
                policyId
                policyName
                typeImage
                updatedOn
            }
    }
}
  `
}

export const GET_POLICY_CITIES_FOR_GROUPED_POLICIES = (clientId) => gql`
  query {
    getPolicyCitiesForGroupPolicies(clientId: "${clientId}") {
      city
      count
    }
  }
`
export function GET_LINKED_COMPANIES() {
  return gql`
    query PARENT_CHILD_DETAILS($clientId: String!) {
      getChildAndParentCompanyDetails(clientId: $clientId) {
        parentCompanyDetails {
          id
          clientId
          companyName
          clientType
          receivedDate
          dueDate
          completionDate
          isClaimed
          claimedBy {
            id
            userName
            firstName
            lastName
          }
          status
          userDetails {
            userName
            firstName
            lastName
            mobileNumber
            emailId
            groups
            roles
            clientId
            policyHolderType
            tagLine
          }
          numberOfPolicies
          isChildCompany
          parentClientId
          globalParentId
          childClientIds
        }
        globalParentCompanyDetails {
          id
          clientId
          companyName
          clientType
          receivedDate
          dueDate
          completionDate
          isClaimed
          claimedBy {
            id
            userName
            firstName
            lastName
          }
          status
          userDetails {
            userName
            firstName
            lastName
            mobileNumber
            emailId
            groups
            roles
            clientId
            policyHolderType
            tagLine
          }
          numberOfPolicies
          isChildCompany
          parentClientId
          globalParentId
          childClientIds
        }
        childCompanyDetailsList {
          id
          clientId
          companyName
          clientType
          receivedDate
          dueDate
          completionDate
          isClaimed
          claimedBy {
            id
            userName
            firstName
            lastName
          }
          status
          userDetails {
            userName
            firstName
            lastName
            mobileNumber
            emailId
            groups
            roles
            clientId
            policyHolderType
            tagLine
          }
          numberOfPolicies
          isChildCompany
          parentClientId
          globalParentId
          childClientIds
        }
      }
    }
  `
}
